// Store de configurações — configs gerais e alertas mobile
import { apiGet, apiPost } from '@/api/conserv';

// Lista dispositivos móveis cadastrados para alertas
export async function listaMobs(cnpj) {
    return apiGet(`api/ConfigMob/ListaMobs?cnpj=${cnpj}`);
}

// Grava uma configuração do usuário (chave/valor)
export async function gravaConfig(tipo, dados) {
    return apiPost(`api/Configs/GravaConfig?tipo=${tipo}`, dados);
}

// Lista todas as configurações do usuário
export async function listaConfigs() {
    return apiGet('api/Configs/ListaConfigs');
}

// Busca uma configuração por chave
export async function getConfig(key) {
    return apiGet(`api/Configs/GetConfig?key=${encodeURIComponent(key)}`);
}

// Busca todas as configurações de uma categoria (tipo) — retorna dict { chave: { valor, json } }
export async function getConfigsByTipo(tipo) {
    return apiGet(`api/Configs/GetConfigsByTipo?tipo=${encodeURIComponent(tipo)}`);
}

// Grava configurações completas (objeto completo de configs)
export async function gravaConfigFull(dados) {
    return apiPost('api/Configs/GravaConfigFull', dados);
}

// Busca configuração de alertas por chave
export async function listaConfigAlerta(key) {
    return apiGet(`api/Configs/ListaConfigAlerta?key=${key}`);
}

// Busca configuração geral do sistema (heartbeat/sync)
export async function getConfigGeral(dados) {
    return apiPost('api/Geral/GetConfigGeral', dados);
}

// Busca dados iniciais do sistema (sync status)
export async function getDadosIniciais() {
    return apiGet('api/Geral/DadosIniciais');
}
